export default __webpack_public_path__ + "static/media/ENFP-2.a69b7ecf.png";